import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription, map, tap } from 'rxjs';
import { MktContentStorageService, MktEnvironmentService } from 'src/app/core/services';
import { ClientPlatformService } from 'src/app/common/services';
import { isTabletAndBeyondSize, isMobileSize } from 'src/app/common/utils/bowser.util';
import { MktCommonModule } from 'src/app/common/mkt-common.module';



@Component({
  selector: 'app-pdp-compare-cards',
  templateUrl: './pdp-compare-cards.component.html',
  styleUrls: ['./pdp-compare-cards.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class PdpCompareCardsComponent implements OnInit, OnDestroy {

  cardImageSize = 'sm';
  cardDetails: any = null;
  compareCardsActive = false;
  compareCardsContent: any = null;
  routeSub: Subscription = new Subscription();
  imagePrefix: string;
  hrefTarget = '_blank';
  @Output() applyNowClicked = new EventEmitter<any>();

  isMobileScreenSize$;
  isTabletAndBeyondSize$;

  constructor(
  private readonly _mktContentStorageService: MktContentStorageService,
  private readonly mktEnvironmentService: MktEnvironmentService,
  private readonly route: ActivatedRoute,
  private readonly clientPlatformService: ClientPlatformService,
  ) {
      this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');

      this.isMobileScreenSize$ = this.clientPlatformService.windowWidth$.pipe(isMobileSize(769), map(width => width ? true : false));
      this.isTabletAndBeyondSize$ = this.clientPlatformService.windowWidth$.pipe(isTabletAndBeyondSize(769), map(width => width ? true : false));
  }

  ngOnInit(): void {
    this.getContent();
  }

  ngOnDestroy(): void{
    this.routeSub.unsubscribe();
  }
  private getContent(): void {
    this.routeSub = combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');

      // Try to get card details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject) {
        return;
      }
      this.cardDetails = mainPdpContentObject?.['TEXT'] && JSON.parse(mainPdpContentObject['TEXT']);
      this.compareCardsContent = mainPdpContentObject?.['compareCards'] && JSON.parse(mainPdpContentObject['compareCards']);
      this.compareCardsActive = this.compareCardsContent?.['compareCardsActive'] || false;
      if (!this.compareCardsContent || !this.compareCardsActive) { return; }
      if(this.compareCardsContent?.iconPathApplicableYes){
        this.compareCardsContent.iconPathApplicableYes= this.imagePrefix + this.compareCardsContent.iconPathApplicableYes;
      }
      if(this.compareCardsContent?.iconPathApplicableNo){
        this.compareCardsContent.iconPathApplicableNo= this.imagePrefix + this.compareCardsContent.iconPathApplicableNo;
      }
    });
  }

  applyNow(value){
    this.applyNowClicked.emit(value);
  }
}
